/**
 * fuarKatalogSekmesi.js — Firma Kartı'nın "Fuar Katalog Bilgileri" sekmesi bu girişin panelinde görünür mü? (backlog #528, 2026-10-21)
 *
 * SAKA personeli bunu Sistem Ayarları > Portal Arayüzleri'nden, arayüz seti başına seçer: sekme, aktif setin `FUAR_KATALOG` modülü en az
 * READ ise görünür (NONE = bu sette sekme yok). Backend henüz bu modülü bilmiyorsa (ya da aktif set yoksa) `moduller.FUAR_KATALOG`
 * hiç gelmez: o zaman sekme eskisi gibi görünür — kart bugüne kadar herkese açıktı, anahtar gelene kadar kimse bir şey kaybetmez.
 * Düzenleme düğmesi ayrıca FIRMA_PROFILI en az WRITE ister (sayfa ona bakar); bu yalnızca GÖRÜNÜRLÜK.
 */
import { enAz, MODUL, SEVIYE } from "../../services/portalService";

export const FUAR_KATALOG_MODULU = MODUL.FUAR_KATALOG;

/** @param portal usePortal() değeri (personelde null). */
export function fuarKatalogSekmesiAcik(portal) {
  const seviye = portal?.aktif?.moduller?.[FUAR_KATALOG_MODULU];
  if (seviye == null) return true;
  return enAz(seviye, SEVIYE.READ);
}
